"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DATA_OVERFLOWING: function() {
        return DATA_OVERFLOWING;
    },
    DATA_OVERFLOW_GROUP: function() {
        return DATA_OVERFLOW_GROUP;
    }
});
const DATA_OVERFLOWING = 'data-overflowing';
const DATA_OVERFLOW_GROUP = 'data-overflow-group';
